const $ = require('jquery');
// const toastr = require('./toastr-config');
const notifications = require('./custom-notifications');
const parser = require('./parser');
const dispatcher = require('../dispatcher');
const SubtitleScope = require('../scopes/subtitle');
const STATUSES = SubtitleScope.VARIABLES.STATUSES;
import { consts} from './consts';

module.exports = function () {

	initEventListeners();

	function initEventListeners() {
		dispatcher.subscribe(dispatcher.events.DB_UPDATE_SUBTITLE, editCaption);
		dispatcher.subscribe(dispatcher.events.DB_INSERT_SUBTITLE, insertCaption);
		dispatcher.subscribe(dispatcher.events.DB_RESET_SUBTITLE, resetCaption);
		dispatcher.subscribe(dispatcher.events.DB_DELETE_SUBTITLE, deleteCaption);
		dispatcher.subscribe(dispatcher.events.DB_DELETE_PERMANENT_SUBTITLE, deletePermanentCaption);
	}

	function editCaption(params) {
		var data;
		if (params.changes) {
			params.changes.editType = params.status;
			data = parser.parseFromChanges(params.item, params.changes, params.force)
		} else {
			data = parser.parseSubtitle(params.item, params.force)
		}

		if (data == null) {
			return;
		}
		data.editType = params.status != null ? params.status : data.editType;

		return doAjaxCall(data, 'EditCaption')
			.then(() => {
				onEditCaptionSuccess(params.item.id)
			});
	}

	function insertCaption(params) {
		var data = parser.parseForInsert(params);

		if (!data) return;
		data.editType == params.status != null ? params.status : STATUSES.NEW;

		return doAjaxCall(data, 'InsertCaption')
			.then((response) => {
				onInsertCaptionSuccess(params.item, response.id)
			})
	}

	function resetCaption(params) {
		var data = parser.parseSubtitle(params.item, true);
		if (!data) return;

		data.editType == params.status != null ? params.status : data.editType;

		return doAjaxCall(data, 'ResetCaption');
	}

	function deleteCaption(params) {
		var data = parser.parseSubtitle(params.item, true);
		if (!data) return;

		data.editType == params.status != null ? params.status : STATUSES.DELETED;

		return doAjaxCall(data, 'DeleteCaption');
	}

	function deletePermanentCaption(item) {
		var data = parser.parseSubtitle(item, true);
		if (!data) return;

		return doAjaxCall(data, 'DeletedPermanently');
	}

	async function doAjaxCall(data, endpoint) {
		if (window.playerConfig && window.playerConfig.isDemo) {
			return Promise.resolve({
				id: Math.ceil(Math.random() * 5000)
			});
		}
		//https://www.capnsub.com/controllers;
		//http://localhost:11956/controllers; 
		//https://test.capnsub.com/controllers;
		//https://direct.capnsub.com/controllers;
		
		return new Promise(async (resolve, reject) => {
			var ajaxRrequestConfig = {
				url: consts.BASE_END_POINT + '/player/' + endpoint,
				type: 'POST',
				data: data,
				// dataType: 'json', //Cause error when response is not json
				success: (response) => {
					resolve(response);
					dispatcher.emit(dispatcher.events.UPDATE_LAST_SYNC_TIME);
				},
				error: (request, status, error) => {
					displayErrorMessage(request, status, error);
	
					dispatcher.emit(dispatcher.events.DB_UPDATE_SUBTITLE_FAILURE);
	
					reject(error);
				}
			}
			
			//The player can be compiled for linnet, in this case linnet will expose function on the window 
			if (ENVIRONMENT == "LINNET" && window.getAccessToken) {
				ajaxRrequestConfig.headers = {
					'Authorization': await window.getAccessToken()
				}
			}

			$.ajax(ajaxRrequestConfig);
		});
	}

	function onEditCaptionSuccess(captionId) {
		notifications.success('Subtitle edited', '', 3000);
	}

	function onInsertCaptionSuccess(newCaptionItem, newCaptionId) {
		newCaptionItem.set('id', newCaptionId);
		notifications.success('Subtitle inserted', '', 3000);
	}

	function displayErrorMessage(request, status, error)  {
		var errorMessage  = "";
		switch (request.status) {
			case 401:
				errorMessage = "Subtitles cannot be edited \n\n in InWork mode!!";
				break;
			default:
				errorMessage = "Communication Error \n\nPlease check your internet connection \n\n and reload the page."
				break;
		}
		
		notifications.error(errorMessage, '', 3000);
	}
};





 










// WEBPACK FOOTER //
// ./app/helpers/ajax-communication.js